module.exports = __webpack_public_path__ + "img/fruit-persimmons-190x100.2b9c3ea3.jpg";